export const columns = [
  // {
  //   id: "Attachment",
  //   label: "پیوست",
  //   minWidth: 120,
  //   align: "center"
  // },
  // {
  //   id: "cBrokerSpcName",
  //   label: "کارگزار",
  //   minWidth: 120,
  //   align: "center"
  // },
  {
    id: "trade_date",
    label: "تاریخ عرضه",
    minWidth: 120,
    align: "center"
  },
  {
    id: "commodity_id",
    label: "نام کالا",
    minWidth: 120,
    align: "center",
  },

  {
    id: "offer_symbol",
    label: "نماد",
    minWidth: 120,
    align: "left",
  },
  {
    id: "manufacturer_id",
    label: "تولید کننده",
    minWidth: 120,
    align: "right",
  },

  {
    id: "offer_volume",
    label: "حجم کالای قابل عرضه",
    minWidth: 120,
    align: "center",
  },
  {
    id: "contract_type_id",
    label: "نوع قرارداد",
    minWidth: 120,
    align: "center",
  },
  {
    id: "offer_base_price",
    label: "قیمت پایه",
    minWidth: 120,
    align: "center",
  },
  {
    id: "maximum_price",
    label: "بالاترین قیمت",
    minWidth: 120,
    align: "center",
  },
  {
    id: "minimum_price",
    label: "پایین ترین قیمت",
    minWidth: 120,
    align: "center",
  },
    {
    id: "final_weighted_average_price",
    label: "قیمت پایانی",
    minWidth: 120,
    align: "center",
  },
  {
    id: "supplier_id",
    label: "مکان تحویل",
    minWidth: 120,
    align: "center",
  },
  {
    id: "currency_id",
    label: "نوع ارز",
    minWidth: 120,
    align: "center",
  },
  {
    id: "measurement_unit_id",
    label: "واحد",
    minWidth: 120,
    align: "center",
  },
  {
    id: "settlement_type_name",
    label: "نوع تسویه",
    minWidth: 120,
    align: "center",
  },
  {
    id: "packaging_type_name",
    label: "بسته بندی",
    minWidth: 120,
    align: "center",
  },
  {
    id: "list",
    label: " مقایسه",
    minWidth: 120,
    align: "center",
  },
];
